import { render, staticRenderFns } from "./DeviceCard.vue?vue&type=template&id=33bd7998&scoped=true&"
import script from "./DeviceCard.vue?vue&type=script&lang=js&"
export * from "./DeviceCard.vue?vue&type=script&lang=js&"
import style0 from "./DeviceCard.vue?vue&type=style&index=0&id=33bd7998&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bd7998",
  null
  
)

export default component.exports